import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "leading-none"
};
import { Team } from "@/modules/team/entity";
import { app } from "@/di";
import GateManager from "@/modules/action-points/services/GateManager";
import { EventEmitter } from "@/modules/base/events";
import AfterCurrencyChangeEvent from "@/modules/action-points/ events/AfterCurrencyChangeEvent";
import ExchangeActionSheet from "@/modules/action-points/components/ExchangeActionSheet.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Gate',
  props: {
    type: null,
    meta: null,
    value: null,
    size: null,
    disabled: {
      type: Boolean
    },
    noConfirm: {
      type: Boolean
    }
  },
  emits: ['action'],
  async setup(__props, {
    emit
  }) {
    let __temp, __restore;
    const props = __props;
    const gate = ref(app.get(GateManager).getGate(props.type));
    const actionSheet = ref(null);
    const team = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(() => useInitial(async () => {})), __temp = await __temp, __restore(), __temp);
    onBeforeUnmount(app.get(EventEmitter).onOff([AfterCurrencyChangeEvent], refresh));
    const onConfirm = async () => {
      if (!(await gate.value.currency.can(props.value))) {
        nextTick(() => actionSheet.value.show());
        return;
      }
      const commit = async () => {
        team.value = await Team.current();
        await gate.value.currency.subtract(props.value, props.meta);
      };
      emit('action', commit);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default", {}, () => [(_openBlock(), _createBlock(_resolveDynamicComponent(gate.value.component), _mergeProps({
        value: __props.value,
        size: __props.size,
        disabled: __props.disabled,
        noConfirm: __props.noConfirm
      }, Object.assign({}, _ctx.$attrs, {
        class: null
      }), {
        onConfirm: onConfirm
      }), _createSlots({
        _: 2
      }, [_ctx.$slots.label ? {
        name: "label",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "label")])
      } : undefined]), 1040, ["value", "size", "disabled", "noConfirm"]))])]), _createVNode(ExchangeActionSheet, {
        ref_key: "actionSheet",
        ref: actionSheet,
        type: __props.type
      }, null, 8, ["type"])]);
    };
  }
});